import React from "react";
import FooterUI from "./FooterUI";

const Footer = () => {
  return <FooterUI />;
};

export default Footer;
